import { FormFieldTypes } from "../../../data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";

export const CreateManualAccountData = {
    name: "CreateAccountManagement",
    initialState: {
        name: '',
        email: '',
        gMPTier: '',
        validFrom: '',
        Validto: '',
        Appeal: '',
        Transitioning: '',
        Distinguished: '',
        GMACourse: '',
        InternalNotes: '',
        fileName: '',
    },
    formFields: [
        {
            id: "name",
            lable: " Name",
            Field_Name: " Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "name",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 mb-3"
            }
        },
        {
            id: "email",
            lable: " Primary Email",
            Field_Name: " Primary Email",
            fieldType: FormFieldTypes.INPUT,
            dataField: "email",
            fieldSetting: {
                placeholder: "",
                allowSpace: false,
            },
            validation: [{ type: "require" }, { type: "email" }],
            style: {
                containerCss: "col-lg-12 mb-3",
            },
        },
        {
            id: "gMPTier",
            lable: "GMP Tier",
            Field_Name: "GMP Tier",
            fieldType: FormFieldTypes.SELECT,
            dataField: "gMPTier",
            fieldSetting: {
                placeholder: " ",
                options: []
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-12 mb-3"
            }
        },
        {
            id: "validFrom",
            lable: "Valid From",
            Field_Name: "Valid Form",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "validFrom",
            fieldSetting: {
                placeholder: "Select",
                allowSpace: true,
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-6 mb-2",
            },
        },
        {
            id: "Validto",
            lable: "Valid To",
            Field_Name: "Valid To",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "Validto",
            fieldSetting: {
                placeholder: "Select",
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-6 mb-2 ",
            }
        },
        {
            id: "Appeal",
            lable: "Appeal",
            Field_Name: "Appeal",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "Appeal",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "Transitioning",
            lable: "Transitioning",
            Field_Name: "Transitioning",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "Transitioning",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "Distinguished",
            lable: "Distinguished",
            Field_Name: "Distinguished",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "Distinguished",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "GMACourse",
            lable: "GMA Course",
            Field_Name: "GMA Course",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "GMACourse",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "InternalNotes",
            lable: "Internal Notes",
            Field_Name: "Internal Notes",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "InternalNotes",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-12 mb-2",
            },
        },
        {
            id: "fileName",
            lable: "File Name",
            Field_Name: "File Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "fileName",
            fieldSetting: {
                placeholder: "",
                allowSpace: false,
            },
            //validation: [{ type: "require" }, { type: "email" }],
            style: {
                containerCss: "col-lg-10 mb-3 mt-2",
            },
        },
        {
            id: "UploadFile",
            lable: "",
            Field_Name: "Upload File",
            fieldType: FormFieldTypes.FILE,
            dataField: "UploadFile",
            fieldSetting: {
                isDownloadable: true,
                acceptedFiles: '.jpg, .png , .pdf, .jpeg',
                maxFileSizeInKB: 2048,
            },
            style: {
                containerCss: "col-md-2 mt-auto mb-3",
            },
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}

export const CreateManualAccountconfig = {
    columns: [

        {
            name: "File Name",
            fieldName: "fileName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "File Link",
            fieldName: "uploadedFileName",
            allowShort: false,
            colType: GridColumnType.LINK,
            colSettings: {
                isOpenNewTab: true,
                url: "$certificateLink", // need to add that property in our object  
            },
        },
    ],
};